(function() { window.GUID_1c0f962f_0cf8_4d14_a170_66a5d1c060c5 = { getGuid: function() { return "1c0f962f-0cf8-4d14-a170-66a5d1c060c5"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PromotionModal {
            static get instance() {
                if (!PromotionModal._instance) {
                    PromotionModal._instance = new PromotionModal();
                }
                return PromotionModal._instance;
            }
            constructor() { }
            static show(props) {
                return new Promise((resolve, reject) => {
                    try {
                        const { instance } = PromotionModal;
                        const url = CS.Url.CSUrl("PromotionModal");
                        if (CS.Helper.isNullOrWhiteSpace(url)) {
                            Controls.ScriptErrorLogger.DisplayError({
                                message: "The url for the promotion modal is not defined.",
                                file: "PromotionModal.ts",
                            });
                            throw new Error("The url for the promotion modal is not defined.");
                        }
                        Controls.Popup.ShowAjaxModal(url, props, ({ popup, isPopup }) => {
                            var _a;
                            if (isPopup) {
                                const popupId = (_a = popup === null || popup === void 0 ? void 0 : popup.$Control) === null || _a === void 0 ? void 0 : _a.attr("id");
                                if (!CS.Helper.isNullOrWhiteSpace(popupId)) {
                                    instance.popupId = popupId;
                                    const buttonId = popupId.replace("popup-", "button-") + "-close-popup";
                                    popup.$Control.offon("click.contentclosebtn", `#${buttonId}`, (e) => {
                                        popup.Proceed = true;
                                        const $button = $(e.currentTarget);
                                        const extraData = $button.data("html");
                                        if (extraData === null || extraData === void 0 ? void 0 : extraData.IsSubscribeNow) {
                                            popup.CustomData = {
                                                IsSubscribeNow: true,
                                                CancelSubscriptionUrl: extraData.CancelSubscriptionUrl,
                                                CancelSubscriptionId: extraData.CancelSubscriptionId,
                                                CancelSubscriptionReturnUrl: extraData.CancelSubscriptionReturnUrl,
                                            };
                                        }
                                        popup.Close();
                                    });
                                }
                            }
                            //const $popupInner = popup.$Control.find(".popup-inner");
                            //if ($popupInner.length) {
                            //    CS.Helper.ConfettiHelper.start($popupInner);
                            //    Lag("cs-promotion-modal", 1000 * 3, () => {
                            //        CS.Helper.ConfettiHelper.stop();
                            //    });
                            //}
                        }, ({ popup }) => {
                            var _a, _b, _c, _d;
                            instance.popupId = null;
                            //CS.Helper.ConfettiHelper.stop();
                            if (popup.Proceed) {
                                if ((_a = popup.CustomData) === null || _a === void 0 ? void 0 : _a.IsSubscribeNow) {
                                    const url = (_b = popup.CustomData) === null || _b === void 0 ? void 0 : _b.CancelSubscriptionUrl;
                                    const subscriptionId = (_c = popup.CustomData) === null || _c === void 0 ? void 0 : _c.CancelSubscriptionId;
                                    const returnUrl = (_d = popup.CustomData) === null || _d === void 0 ? void 0 : _d.CancelSubscriptionReturnUrl;
                                    if (!CS.Helper.isNullOrWhiteSpace(url) &&
                                        !CS.Helper.isNullOrWhiteSpace(returnUrl) &&
                                        subscriptionId &&
                                        !isNaN(subscriptionId)) {
                                        CS.Ajax.Post(url, { subscriptionId }, (response) => {
                                            if (response.result == true) {
                                                CS.Nav.Go(returnUrl);
                                            }
                                            else {
                                                Controls.Snackbar.Show({
                                                    Id: "subscription-cancel-error",
                                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                                    Type: CS.Enumeration.SnackbarType.Danger,
                                                    AutoHideDuration: 3000,
                                                    Message: JSRess.AnErrorOccurredPleaseTryAgainLater,
                                                });
                                            }
                                        });
                                    }
                                }
                            }
                            return resolve(popup.Proceed);
                        }, true, false, true);
                    }
                    catch (error) {
                        console.error("An error occurred while showing the promotion modal.", error);
                        return reject(error);
                    }
                });
            }
            static setAnalyticsData(props) {
                CS.Analytics.Event(`Promotion-${props.promotionType}`, `PopupSeen`, props.displayPeriod);
                if (window.clarity) {
                    const customTagKey = `Promotion-${props.promotionType}-${props.displayPeriod}`;
                    const customTagValue = `PopupSeen`;
                    window.clarity("set", customTagKey, customTagValue);
                }
            }
        }
        Controls.PromotionModal = PromotionModal;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PromotionModal.js.map
